const CookiePolicy = () => {
  return (
    <>
      <div className="max-w-5xl mx-auto px-4 py-12 font-poppins text-gray-800">
        {/* Heading */}
        <h1 className="text-4xl font-bold mb-4">Cookie Privacy Policy</h1>

        {/* Lead sentence */}
        <p className="text-xl font-medium text-gray-700 mb-10">
          We use cookies to enhance your experience. By using our site, you
          agree to our cookie policy.
        </p>

        <hr className="mb-10" />

        {/* Intro paragraph */}
        <p className="mb-10">
          This Cookie Privacy Policy explains how we employ cookies on our
          website to enhance your user experience. By engaging with
          Lentera Technologies, you implicitly consent to the use of cookies as
          delineated in this policy.
        </p>

        {/* I. What are cookies? */}
        <h2 className="text-xl font-semibold mb-3">I. What Are Cookies?</h2>
        <p className="mb-10">
          Cookies are diminutive text files stored on your
          device&nbsp;(computer, smartphone, tablet) when you visit websites.
          They play a crucial role in optimizing website functionality and
          providing an improved user experience.
        </p>

        {/* II. Types */}
        <h2 className="text-xl font-semibold mb-3">II. Types of Cookies</h2>

        <h3 className="font-semibold mb-1">1. Essential Cookies</h3>
        <p className="mb-6">
          Essential cookies are imperative for the fundamental functionality of
          our website. They enable seamless navigation, use of essential
          features, and access to secure areas.
        </p>

        <h3 className="font-semibold mb-1">
          2. Performance and Analytics Cookies
        </h3>
        <p className="mb-6">
          Utilizing these cookies, we gather information about visitor
          interactions with our website. This data aids in analyzing user
          behavior, refining our services, and enhancing the overall user
          experience.
        </p>

        <h3 className="font-semibold mb-1">3. Functionality Cookies</h3>
        <p className="mb-6">
          Functionality cookies enable us to recall your preferences and
          choices&nbsp;(such as language or region) for a more personalized
          experience.
        </p>

        <h3 className="font-semibold mb-1">
          4. Advertising and Marketing Cookies
        </h3>
        <p className="mb-10">
          Lentera Technologies and our third-party partners may employ these
          cookies to deliver relevant advertisements and promotional materials
          based on your interests and online behavior.
        </p>

        {/* III. How we use */}
        <h2 className="text-xl font-semibold mb-3">III. How We Use Cookies</h2>
        <p className="mb-10">
          We employ cookies to&nbsp;—&nbsp;(i) provide and enhance our website
          and service, (ii) personalize your experience, (iii) analyze site
          traffic and user behavior, and (iv) deliver targeted advertisements.
        </p>

        {/* IV. Managing */}
        <h2 className="text-xl font-semibold mb-3">IV. Managing Cookies</h2>
        <p className="mb-10">
          You can manage or delete cookies in your browser settings. Blocking
          cookies may affect site functionality. Please consult your browser's
          help documentation for guidance.
        </p>

        {/* V. Third‑party */}
        <h2 className="text-xl font-semibold mb-3">V. Third-Party Cookies</h2>
        <p className="mb-10">
          Some cookies are set by third-party service providers—such as
          advertising networks and analytics platforms—who may collect
          information about your online activities across sites.
        </p>

        {/* VI. Changes */}
        <h2 className="text-xl font-semibold mb-3">
          VI. Changes to Our Cookie Policy
        </h2>
        <p className="mb-10">
          We may update this policy to reflect changes in our cookie practices
          or legal requirements. Any revisions will be posted here with a new
          effective date.
        </p>

        {/* VII. Contact */}
        <h2 className="text-xl font-semibold mb-3">VII. Contact Us</h2>
        <p>
          For inquiries or concerns about our use of cookies, please reach out
          via the contact information provided on our website.
        </p>
      </div>
    </>
  );
};

export default CookiePolicy;
